import * as ng from 'angular';

export class ContractStep2Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        'store',
        '$state',
        '$uibModal',
        'contractPDF',
        'pdfPath',
        'contractPdfPreviewType'
    ];

    constructor(
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private $state: ng.ui.IStateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private contractPDF: any,
        private pdfPath: any,
        private contractPdfPreviewType: any
    ) {
        $scope.user = store.get('registeringUser');
        $scope.user.organizationData.contactPerson.contractFileId = pdfPath;
        store.set('registeringUser', $scope.user);
        $scope.isPDF = false;

        $scope.pdfContent = contractPDF;

        if (contractPdfPreviewType === 'pdf') {
            $scope.isPDF = true;
        }

        $scope.openSignContractModal = (size) => {
            let WorkerChatModal = $uibModal.open({
                animation: true,
                component: 'signContractModalComponent',
                controllerAs: 'vm',
                size: size === 'undefined' ? 'md' : size,
                backdrop: 'static',
                keyboard: false,
                resolve: {
                }
            });
        };

        $scope.prev = () => {
            store.set('registeringUser', $scope.user);
            $state.go('registration.contract-step1');
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/contract-step2/contract-step2.controller.ts